export default __webpack_public_path__ + "static/media/edital12.7d0d542d.pdf";